// GallerySection.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { galleryData } from '../data/galleryData';
import '../styles/gallery.css';

const GallerySection = () => {
  const { sectionId } = useParams();
  
  // Find the section data based on the folder name from URL
  const sectionData = galleryData.find(section => section.folder === sectionId);
  
  if (!sectionData) {
    return (
      <div className="gallery-section-page">
        <Navbar />
        <div style={{ padding: '4rem', textAlign: 'center' }}>
          <h2>Gallery section not found</h2>
          <Link to="/gallery" className="back-link">← Back to Gallery</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="gallery-section-page">
      <Navbar />
      
      {/* Featured Image - Full Screen with Overlay */}
      <div className="featured-image-container">
        <img 
          src={sectionData.images[0].src} 
          alt={sectionData.images[0].alt}
          className="featured-image"
        />
        <div className="hero-overlay-content">
          <Link to="/gallery" className="back-to-gallery-hero">
            ← Back to Gallery
          </Link>
          <h1 className="hero-title">{sectionData.section}</h1>
          <Link to={sectionData.navLink} className="view-service-link-hero">
            View Service Details →
          </Link>
        </div>
        <p className="image-caption-simple">
          {sectionData.images[0].alt}
        </p>
      </div>

      {/* Image Grid - Non-clickable thumbnails */}
      <div className="image-grid-container">
        <h2 className="grid-title">More {sectionData.section} Projects</h2>
        <div className="image-grid">
          {sectionData.images.slice(1).map((image, idx) => (
            <div
              key={idx}
              className="grid-image-button"
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="grid-image"
              />
              <p className="grid-image-caption">
                {image.alt}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Section CTA */}
      <section className="section-cta">
        <h3>Interested in {sectionData.section}?</h3>
        <div className="cta-buttons-simple">
          <Link to="/contact" className="button-primary-simple">Get a Quote</Link>
          <Link to={sectionData.navLink} className="button-secondary-simple">Learn More</Link>
        </div>
      </section>
    </div>
  );
};

export default GallerySection;